import React, {useContext, useState} from 'react';
import {BoShowContext} from "../context/bo-show-context.jsx";
import Button from "../../../../../components/button/button.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import Dropzone from "../../../../../components/dropzone/dropzone.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import projectUtils from "../../../../../utils/project-utils.js";
import bosService from "../../../../../services/web/bos-service.js";
import {toast} from "react-toastify";

const BoShowAddOtherDocuments = () => {
    const {id, dataFetch, setIsLoading, refetch, otherDocumentTypes} = useContext(BoShowContext);
    const addOtherDocument = dataFetch?.bogcm?.actions?.addOtherDocument;

    const [attaches, setAttaches] = useState([]);
    const [state, setState] = useState({type: "", value: ""})

    if (!addOtherDocument) return null;

    const onClick = () => {
        if (!state.type){
            projectUtils.swalErrorMessage("", "O campo \"Tipo\" é obrigatório.");
            return;
        }

        projectUtils.swalMessage(
            "warning",
            "Adicionar documento",
            `Deseja adicionar o documento?`,
            "Sim",
            true,
            "Não",
            ({isConfirmed}) => {
                if (isConfirmed) {
                    const formData = new FormData();

                    formData.append('id', id);
                    formData.append('type', state.type);
                    formData.append('value', state.value);

                    attaches.forEach((attach, index) => {
                        formData.append(`file[${index}]`, attach)
                    })

                    setIsLoading(true)
                    bosService.addOtherDocument(formData)
                        .then(() => {
                            refetch();
                            toast.success("Documento adicionado com sucesso");
                            setAttaches([]);
                            setState({type: "", value: ""})
                        })
                        .catch(error => {
                            console.error(error);
                            let message = `Erro ao adicionar documento`;
                            if (error.response.status !== 500) {
                                message = error.response.data.message;
                            }

                            projectUtils.swalErrorMessage('', message, 'Ok');
                        })
                        .finally(() => setIsLoading(false))
                }
            }
        )
    }

    return (
        <div className={"print:hidden"}>
            <hr className={"opacity-25 text-[#676a6c]"}/>
            <article className={"space-y-4"}>
                <h2 className={"text-center"}>Adicionar documentos</h2>

                <SentryRow>
                    <SelectComponent
                        id="otherDocumentType"
                        value={state.type}
                        options={otherDocumentTypes}
                        label={"Tipo *"}
                        classNameWrapper={"col-span-6"}
                        onChange={(selected) => setState(prev => ({...prev, type: selected?.value}))}
                    />

                    <InputForm
                        id={"otherDocumentValue"}
                        value={state.value}
                        label={"Número / Nome"}
                        classNameWrapper={"col-span-6"}
                        onChange={({target}) => setState(prev => ({...prev, value: target.value}))}
                    />
                </SentryRow>

                <section>
                    <p>Anexos</p>
                    <Dropzone
                        attaches={attaches}
                        setAttaches={setAttaches}
                    />
                </section>

                <Button
                    className={"justify-self-end"}
                    onClick={onClick}
                    actionFeedbackType="save"
                    deferActionFeedback
                    loadingText="Adicionando..."
                    successText="Documento adicionado com sucesso"
                >
                    Adicionar documento
                </Button>
            </article>
        </div>
    );
};

export default BoShowAddOtherDocuments;